import axios from 'axios';
import cookie from '../../cookieHelper/cookie';

export default async function getPurchase(purchaseId, signal) {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/purchases/${encodeURIComponent(purchaseId)}`, {
        signal,
        headers: { Authorization: `Bearer ${cookie.getCookie(process.env.REACT_APP_COOKIE_NAME)}` },
    });
    const result = response.data;
    if (String(result?.status?.code) !== '10200' || !result?.data?._id) {
        const error = new Error(result?.status?.message || 'Unable to load purchase.');
        error.response = response;
        throw error;
    }
    return result.data;
}
